import { FC, PropsWithChildren } from "react";

import { cn } from "@/lib/cn";

import { RightAsideContentWrapper } from "../right-aside-content-wrapper";

interface SheetMainContentProps extends PropsWithChildren {
  className?: string;
  transitionKey?: string | number;
}

export const SheetMainContent: FC<SheetMainContentProps> = ({ children, className, transitionKey }) => {
  return (
    <div
      className={cn(
        ["mb-0.5 flex flex-initial grow flex-col overflow-y-auto px-3 py-3 text-secondary-foreground"],
        className,
      )}
    >
      <RightAsideContentWrapper transitionKey={transitionKey}>{children}</RightAsideContentWrapper>
    </div>
  );
};
